import React, { useEffect, createElement } from 'react';
export function Modulo3Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1137">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1138">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1139">
          AI <span className="text-[#F5C842]" data-id="element-1140">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1141">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1142">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1143">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1144">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1145">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1146">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1147">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1148">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1149">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1150">
            Módulo 3 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1151">
            ⏱ 20 minutos · Herramienta: Sales Letter Weapon
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1152">
          La Demo que
          <br data-id="element-1153" />
          <span className="text-[#F5C842]" data-id="element-1154">Cierra Sola</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1155">
          Cómo construir un sitio web profesional para tu prospecto en menos de
          10 minutos — antes de hablar con él. Cuando llegas con la demo lista,
          ya no eres un vendedor. Eres un consultor.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1156">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1157">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1158"></div>
            Herramienta: Sales Letter Weapon en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1159">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1160"></div>
            Demo lista en menos de 2 minutos
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1161">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1162"></div>5 demos
            listas para presentar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1163">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1164">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1165">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1166"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1167">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1168">
              <iframe src="https://player.vimeo.com/video/1179701415?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 3" data-id="element-1169" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 3 */}
        <div className="mt-4 mb-10" data-id="element-1170">
          <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1171">
            <span className="text-[20px]" data-id="element-1172">📝</span>
            Abrir Sales Letter Weapon en Heylloyd
            <span className="text-[18px] font-black" data-id="element-1173">→</span>
          </a>
        </div>

        {/* STRATEGY BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-[28px] py-[24px]" data-id="element-1174">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1175">
            ⚡ La Estrategia que Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1176">
            La razón por la que la mayoría falla vendiendo servicios digitales
            es que llegan con palabras:{' '}
            <strong className="text-white" data-id="element-1177">
              "Te puedo hacer un sitio web."
            </strong>{' '}
            El cliente no lo ve. No lo cree. Y no compra.
            <br data-id="element-1178" />
            <br data-id="element-1179" />
            Con este módulo, llegas a la llamada con el sitio web del cliente{' '}
            <strong className="text-white" data-id="element-1180">ya construido</strong>. El cliente lo
            ve, le gusta, y la venta se cierra sola. Tú no convences — tú
            muestras.
          </div>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black p-7" data-id="element-1181">
          <div className="text-[48px] leading-none shrink-0" data-id="element-1182">🧠</div>
          <div data-id="element-1183">
            <div className="mb-1.5 text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1184">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-1185">
              Sales Letter Weapon
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-1186">
              La IA que construye el sitio web del cliente en minutos. Le das la
              información básica del negocio y ella genera una página
              profesional completa, lista para presentar como demo antes de la
              llamada de venta.
            </div>
          </div>
        </div>

        {/* DEMO STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1187">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1188"></span>
          Cómo Construir una Demo en 5 Pasos
        </div>
        <div className="mb-8 flex flex-col gap-3" data-id="element-1189">
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1190">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1191">
              1
            </div>
            <div data-id="element-1192">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1193">
                Abre Sales Letter Weapon en HEYLLOYD
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1194">
                Selecciona el cerebro "Sales Letter Weapon" desde tu panel de
                HEYLLOYD
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1195">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1196">
              2
            </div>
            <div data-id="element-1197">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1198">
                Ingresa el nombre del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1199">
                El nombre exacto del negocio que encontraste en el Módulo 2 con
                Ai Website Arbitrage
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1200">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1201">
              3
            </div>
            <div data-id="element-1202">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1203">
                Ingresa tipo de negocio, ciudad y servicios
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1204">
                Toda esta información ya la tienes de tu lista de prospectos del
                Módulo 2
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1205">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1206">
              4
            </div>
            <div data-id="element-1207">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1208">
                Ingresa el número de teléfono del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1209">
                La IA lo incluirá en la sección de contacto del sitio generado
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1210">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1211">
              5
            </div>
            <div data-id="element-1212">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1213">
                Copia y guarda el link de la demo
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1214">
                En menos de 2 minutos tendrás una página profesional lista para
                enviar al cliente
              </div>
            </div>
          </div>
        </div>

        {/* WHAT IT GENERATES */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1215">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1216"></span>
          Qué Genera Sales Letter Weapon Automáticamente
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-5" data-id="element-1217">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1218">
            <div className="mb-2 text-[24px]" data-id="element-1219">🎨</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1220">
              Logo del negocio
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1221">
            <div className="mb-2 text-[24px]" data-id="element-1222">📝</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1223">
              Descripción de servicios
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1224">
            <div className="mb-2 text-[24px]" data-id="element-1225">🖼️</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1226">
              Galería de fotos
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1227">
            <div className="mb-2 text-[24px]" data-id="element-1228">📍</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1229">
              Sección de contacto y mapa
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1230">
            <div className="mb-2 text-[24px]" data-id="element-1231">📱</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1232">
              Diseño responsive móvil
            </div>
          </div>
        </div>

        {/* INFO NEEDED */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1233">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1234">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1235">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1236"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1237">
                Información que necesitas del negocio
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1238">
              <ul className="flex flex-col" data-id="element-1239">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1240">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1241">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1242">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1243">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1244">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1245">Tipo de negocio</strong>{' '}
                  (restaurante, peluquería, etc.)
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1246">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1247">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1248">Ciudad y dirección</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1249">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1250">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1251">Servicios que ofrece</strong>
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1252">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1253">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1254">Número de teléfono</strong>
                </li>
              </ul>
              <br data-id="element-1255" />
              <em className="text-[11px] text-[#555]" data-id="element-1256">
                ✓ Todo esto lo encontraste en el Módulo 2 con Ai Website
                Arbitrage
              </em>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1257">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1258">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1259"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1260">
                ¿Tiene que ser perfecta la demo?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1261">
              <strong className="text-white" data-id="element-1262">No.</strong> No tiene que ser
              perfecta. Tiene que ser{' '}
              <strong className="text-white" data-id="element-1263">
                profesional y mucho mejor que lo que tienen ahora
              </strong>
              . Eso es todo lo que necesitas para cerrar la venta.
              <br data-id="element-1264" />
              <br data-id="element-1265" />
              Cuando el cliente ve su negocio representado de forma profesional
              en pantalla, la conversación cambia completamente. Ya no estás
              vendiendo — estás{' '}
              <strong className="text-white" data-id="element-1266">
                mostrando el resultado final
              </strong>
              .
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-1267">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1268">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1269"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1270">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1271">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1272"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1273">
              "Módulo 3. Este es el módulo que más me emociona enseñarte. Voy a
              mostrarte cómo construir un sitio web profesional para tu
              prospecto en menos de 10 minutos, antes de hablar con él. Cuando
              llegues a la llamada con una demo ya lista, la conversación cambia
              completamente. Ya no eres un vendedor. Eres un consultor que ya
              hizo el trabajo."
            </div>
          </div>

          <div className="mb-4" data-id="element-1274">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1275">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1276"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1277">
              "Abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1278">
                'Sales Letter Weapon'
              </span>{' '}
              en HEYLLOYD. Vas a ver que te pide información básica del negocio:
              nombre, tipo de negocio, ciudad, servicios que ofrece y número de
              teléfono. Toda esa información la encontraste en el Módulo 2 con
              el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1279">
                'Ai Website Arbitrage'
              </span>
              ."{'\n\n'}
              "Rellena los campos con la información de tu primer prospecto.
              Ahora observa. En menos de 2 minutos, el cerebro genera una página
              web completa con: el logo del negocio, una descripción de sus
              servicios, una galería de fotos, y una sección de contacto con su
              teléfono y mapa."{'\n\n'}
              "¿Es perfecta? No. ¿Es profesional y mucho mejor que lo que tienen
              ahora? Absolutamente. Y eso es todo lo que necesitas para cerrar
              la venta."{'\n\n'}
              "Guarda el link de la demo. En el Módulo 4, te voy a enseñar
              exactamente qué decir cuando llames a este negocio."
            </div>
          </div>

          <div className="mb-4" data-id="element-1280">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1281">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1282"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1283">
              "Tarea: construye una demo para cada uno de tus 5 prospectos.
              Guarda el link de cada una. Cuando tengas las 5 demos listas,
              estás listo para el Módulo 4 y para hacer tu primera venta."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1284">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1285">
            ✅ Tu Tarea — Módulo 3
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1286">
            Usa <strong className="text-white" data-id="element-1287">Sales Letter Weapon</strong> en
            HEYLLOYD y construye una demo para cada uno de tus{' '}
            <strong className="text-white" data-id="element-1288">5 prospectos</strong>. No hagas
            ninguna llamada sin tener la demo lista primero.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1289">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1290">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1291">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Sales Letter Weapon"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1292">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1293">
                  2
                </div>
                Ingresa la información del Prospecto #1 (nombre, tipo, ciudad,
                servicios, teléfono)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1294">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1295">
                  3
                </div>
                Copia y guarda el link de la demo generada
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1296">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1297">
                  4
                </div>
                Repite para los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1298">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1299">
                  5
                </div>
                <strong className="text-white" data-id="element-1300">
                  Cuando tengas las 5 demos listas, pasa al Módulo 4
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1301">
        <a href="/modulo-2" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-1302">
          ← Módulo 2
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1303">
          AI <span className="text-[#F5C842]" data-id="element-1304">WEB CLOSER</span>
        </div>
        <a href="/modulo-4" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1305">
          Módulo 4: El Cierre Sin Presión →
        </a>
      </div>
    </div>;
}